var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgServiceIcon6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#service-icon-6_svg__a)",
  d: "M10 3h7v12a6 6 0 0 1-6 6H6V7a4 4 0 0 1 4-4"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4A4A4A",
  d: "M10 3h8v14a4 4 0 0 1-4 4h-4z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.5 6a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1zM15.5 8.999a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1zM12.5 11.999a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "service-icon-6_svg__a",
  x1: 5,
  x2: 5,
  y1: 22.35,
  y2: 3,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4EDFC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1
})))));
export default SvgServiceIcon6;